var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
import clsx from "clsx";
import React from "react";
import { filterAttributes } from "../utils";
import Icon from "./Icon";
import DefaultButton from "./Button";
import { visuallyHidden } from "../utils/styles.module.css";
import * as defaultStyles from "./Pagination.module.css";
const defaultLabels = {};
export default function Pagination(_a) {
  var _b = _a,
    {
      buttonUrl,
      className,
      components: {
        Button = DefaultButton
      } = {
        Button: DefaultButton
      },
      onButtonClick,
      page,
      range = 5,
      styles = defaultStyles,
      t = id => defaultLabels[id] || id,
      totalPages
    } = _b,
    restProps = __objRest(_b, ["buttonUrl", "className", "components", "onButtonClick", "page", "range", "styles", "t", "totalPages"]);
  let attributes = filterAttributes(restProps);
  const isFirstPage = page === 0;
  const isLastPage = page === totalPages - 1;
  let pagesToDisplay;
  if (totalPages > range) {
    let min = Math.min(totalPages - range, Math.max(0, page - Math.floor(range / 2)));
    pagesToDisplay = Array.from({
      length: range
    }, (v, i) => min + i);
  } else {
    pagesToDisplay = Array.from({
      length: totalPages
    }, (v, i) => i);
  }
  return /* @__PURE__ */React.createElement("nav", __spreadValues({
    className: clsx(styles.component, className)
  }, attributes), /* @__PURE__ */React.createElement("ul", {
    className: styles.list
  }, /* @__PURE__ */React.createElement("li", {
    className: clsx(styles.item, styles.previous)
  }, /* @__PURE__ */React.createElement(Button, {
    className: styles.button,
    url: !isFirstPage ? buttonUrl && buttonUrl(page - 1) : void 0,
    disabled: isFirstPage,
    components: {
      InertElement: "span"
    },
    onClick: onButtonClick && (() => {
      if (!isFirstPage) {
        onButtonClick(page - 1);
      }
    })
  }, /* @__PURE__ */React.createElement(Icon, {
    name: "arrow-left"
  }), /* @__PURE__ */React.createElement("span", {
    className: styles.itemText
  }, t("previousPage")))), pagesToDisplay.map((pageIndex, index) => {
    return /* @__PURE__ */React.createElement("li", {
      className: clsx(styles.item, pageIndex === page && styles.current, index === 0 && styles.firstInRange, index + 1 === pagesToDisplay.length && styles.lastInRange),
      key: pageIndex
    }, /* @__PURE__ */React.createElement(Button, {
      className: styles.button,
      url: buttonUrl && buttonUrl(pageIndex),
      "aria-current": pageIndex == page ? "page" : null,
      onClick: onButtonClick && (() => {
        onButtonClick(pageIndex);
      })
    }, /* @__PURE__ */React.createElement("span", {
      className: visuallyHidden
    }, t("page"), ": "), pageIndex + 1));
  }), /* @__PURE__ */React.createElement("li", {
    className: clsx(styles.item, styles.next)
  }, /* @__PURE__ */React.createElement(Button, {
    className: styles.button,
    url: !isLastPage ? buttonUrl && buttonUrl(page + 1) : void 0,
    disabled: isLastPage,
    components: {
      InertElement: "span"
    },
    onClick: onButtonClick && (() => {
      if (!isLastPage) {
        onButtonClick(page + 1);
      }
    })
  }, /* @__PURE__ */React.createElement("span", {
    className: styles.itemText
  }, t("nextPage")), /* @__PURE__ */React.createElement(Icon, {
    name: "arrow-right"
  })))));
}